import React from 'react';
import { EntityCard, EntityCardSize, Stack, Box } from '@/components';
import { ReportSearchModel, ReportCardType, UiConfigurationModel } from '@/types';
import { listingGridItemMotion, carouselMotion } from '@/animations';
import classNames from 'classnames';
import ReportCarouselHeading, { ReportHeadingModel } from './ReportCarouselHeading';

type ReportListingGridModel = {
  cards: ReportSearchModel[];
  cardType: ReportCardType;
  heading?: ReportHeadingModel;
  uiConfiguration?: UiConfigurationModel;
  onCardClick?: (e: React.MouseEvent, data: ReportSearchModel) => void;
};

const ReportListingGrid = (data: ReportListingGridModel) => {
  const { cards, cardType, onCardClick } = data;

  return (
    <>
      <ReportCarouselHeading heading={data.heading} hideArrows className="report-listing-grid-heading container" />

      <Stack
        animation={carouselMotion}
        className={classNames(
          'report-listing-grid-container container grid gap-4 lg:gap-6',
          cardType === ReportCardType.VIDEO ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-2 lg:grid-cols-3',
        )}
      >
        {cards.map((card, index) => (
          <div key={index}>
            <Box animation={listingGridItemMotion} className="h-full">
              <EntityCard data={card} cardType={cardType} size={EntityCardSize.AUTO} onClick={onCardClick} />
            </Box>
          </div>
        ))}
      </Stack>
    </>
  );
};

export default ReportListingGrid;
